import logoBundledUrl from '../assets/logo.png';

/** Bundled asset avoids SPA error-page routing eating /logo.svg on some CloudFront setups. */
export const LOGO_URL = import.meta.env.VITE_LOGO_URL || logoBundledUrl;

/**
 * Main public site (quote/invoice customer pages). Admin SPA is hosted separately; relative paths
 * like /itservices/invoice/... must not use the admin origin.
 */
export const PUBLIC_SITE_URL = String(import.meta.env.VITE_PUBLIC_SITE_URL || 'https://www.peaknet.com.au').replace(
  /\/$/,
  ''
);

/** Absolute URL for previews / emails (uses current origin for same-host assets). */
export function logoAbsoluteUrl() {
  const v = import.meta.env.VITE_LOGO_URL;
  if (v && /^https?:\/\//i.test(v)) return v;
  if (typeof window !== 'undefined') {
    if (v) return v.startsWith('/') ? `${window.location.origin}${v}` : v;
    return new URL(logoBundledUrl, window.location.origin).href;
  }
  return `https://admin.peaknet.com.au${logoBundledUrl}`;
}
